export default __webpack_public_path__ + "static/m-team1-c207a4e200035fd7bbb88c924ae1a5fa.png";